// eslint-disable-next-line aloft/no-sui-chakra
import { ChakraProps, chakra } from '@aloft/toolkit-sui/chakra';
import { useSortable } from '@dnd-kit/sortable';

import { ReactNode } from 'react';

const dropLine = {
  content: '""',
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: '2px',
  backgroundColor: 'buttonDefault',
  pointerEvents: 'none',
  zIndex: 2,
} as const;

type Props = {
  id: string;
  styles: ChakraProps;
  children: ReactNode;
  dropSide?: 'left' | 'right';
};

export const DraggableHeader = ({ id, styles, children, dropSide }: Props) => {
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id });

  return (
    <chakra.th
      ref={setNodeRef}
      {...styles}
      {...attributes}
      {...listeners}
      position="relative"
      cursor={isDragging ? 'grabbing' : 'grab'}
      _hover={{ backgroundColor: 'surface4' }}
      _before={dropSide === 'left' ? { ...dropLine, left: 0 } : undefined}
      _after={dropSide === 'right' ? { ...dropLine, right: 0 } : undefined}
    >
      {children}
    </chakra.th>
  );
};
